export const DRAG_TYPES = {
  PRODUCT: 'PRODUCT',
  DAY: 'DAY',
  EXTRA_PRODUCT: 'EXTRA_PRODUCT',
  EXTRA_CONTAINER: 'EXTRA_CONTAINER'
} as const
